<template>
  <div>
    <ul class="add">
      <li>
        <button @click="add" class="btn btn-sm btn-info mr-2 mb-2">
          <span class="ti-plus"></span>
          {{ "new_element" | setText("Новый элемент") }}
        </button>
      </li>
    </ul>
    <ul class="resource-item">
      <template v-for="(item, key) in items">
        <li v-if="item.lessonable" :key="key">
          <div v-if="item.lessonable_type === 'file'">
            <pdf-reader
              v-if="item.lessonable.file"
              :src="item.lessonable.file.path"
            ></pdf-reader>
          </div>
          <div v-else-if="item.lessonable_type === 'html'">
            <quill-editor
              v-model="item.lessonable.layout"
              :options="editorOption"
            />
          </div>
          <div v-else-if="item.lessonable_type === 'video'">
            <!-- <fg-input
              type="text"
              :label="`Ссылка`"
              name="link"
              v-model="item.lessonable.link"
            ></fg-input> -->

            <fg-input
              type="text"
              name="title"
              :label="`Заголовок`"
              v-model="item.lessonable.title"
            ></fg-input>

            <div v-if="item.lessonable.file">
              <a :href="item.lessonable.file" target="_blank">Скачать видео</a>
            </div>

            <file-upload
              :isFile="true"
              :title="`Изменить`"
              v-model="item.lessonable.file_upload"
            ></file-upload>

            <!-- <iframe
              :src="item.lessonable.link"
              :title="item.lessonable.title"
              frameborder="0"
              height="300"
              width="100%"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            >
            </iframe> -->
          </div>

          <div class="control">
            <button
              v-if="item.lessonable_type != 'file'"
              @click="update(item)"
              class="btn btn-sm btn-success mr-2 mb-2"
            >
              <span class="ti-save"></span>
            </button>

            <button
              @click="rejectItem(item, key)"
              class="btn btn-sm btn-danger mb-2"
            >
              <span class="ti-trash"></span>{{ "delete" | setText("Удалить") }}
            </button>
          </div>
        </li>
      </template>
    </ul>

    <modal
      :name="'add'"
      :adaptive="true"
      :clickToClose="false"
      :reset="true"
      :scrollable="true"
      :height="'auto'"
    >
      <card>
        <radio-list v-model="addType" :items="types" :name="`file`" />
        
        <div>
          <div v-if="addType === 'video'">
            <fg-input
              type="text"
              name="video_title"
              :label="`Заголовок видео `"
              v-model="newItem.title"
            ></fg-input>
            <!-- <fg-input
              type="text"
              name="video_link"
              :label="`Ссылка`"
              v-model="newItem.link"
            ></fg-input> -->

            <file-upload
              :isFile="true"
              :title="`Media документ`"
              v-model="newItem.file_upload"
            ></file-upload>
          </div>
          <div v-else-if="addType === 'html'">
            <!-- <quill-editor v-model="newItem.layout" :options="editorOption" /> -->
            <RichEditor v-model="newItem.layout" :options="editorOption" />
          </div>
          <div v-else-if="addType === 'file'">
            <fg-input
              type="text"
              name="title"
              :label="`Заголовок `"
              v-model="newItem.title"
            ></fg-input>
            <file-upload
              :isFile="true"
              :title="`PDF документ`"
              v-model="newItem.mediaFile"
            ></file-upload>
          </div>
        </div>
        <br />
        <div>
          <p-button
            class="mr-2 btn-sm"
            type="info"
            round
            @click.native.prevent="push"
            >{{ "add" | setText("Добавить") }}</p-button
          >

          <p-button
            class="mx-1 btn-sm"
            type="warning"
            round
            @click.native.prevent="$modal.hide('add')"
            >Отмена</p-button
          >
        </div>
      </card>
    </modal>
  </div>
</template>

<script>
import { errorNotify } from "@/plugins/functions";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { toFormData } from "@/_api/_helper";
import RichEditor from "@/components/Editor/RichTextEditor.vue";
import { mapState } from "vuex";
export default {
  components: {
    RichEditor,
  },
  computed: {},
  data: () => ({
    editorOption: {
      modules: {
        toolbar: [
          ["bold", "italic", "underline", "strike", "link", "image"], // toggled buttons
          ["blockquote", "code-block"],

          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ color: [] }, { background: [] }],

          [{ align: [] }],
        ],
      },
    },
    addType: "file",
    cardLink: "",
    newItem: {
      title: "",
      link: "",
      locale: null,
      layout: "",
      mediaFile: null,
      file_upload: null,
    },
    items: [],
    types: [
      { title: "PDF", id: "file" },
      { title: "Видео", id: "video" },
      { title: "Текст", id: "html" },
    ],
  }),
  props: ["id"],
  async created() {
    await this.getData();
  },
  methods: {
    async getData() {
      this.cardLink = `lessonplans/${this.id}/resources`;
      this.$loading(true);
      this.items = await this.$http
        .get(this.cardLink)
        .then((response) => {
          return response.data.data;
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    add() {
      this.$modal.show("add");
    },
    async push() {
      this.$loading(true);
      let item = this.newItem;
      let url = `${this.cardLink}?type=${this.addType}`;
      let newItem = await this.$http({
        method: "post",
        data: toFormData(item),
        url: url,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          this.getData();
          return response.data.data;
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
      this.$modal.hide("add");
      this.items.push(newItem);
    },
    async update(item) {
      this.$loading(true);

      const url = `${this.cardLink}/${item.id}?type=${item.lessonable_type}`;

      let newItem = await this.$http({
        method: "post",
        data: toFormData(item, "PUT"),
        url: url,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          this.getData();
          return response.data.data;
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    async rejectItem(item, key) {
      this.$loading(true);

      let newItem = await this.$http
        .delete(`${this.cardLink}/${item.id}`)
        .then((response) => {
          this.items.splice(key, 1);
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
};
</script>
<style lang="scss">
.add {
  text-align: right;
  position: fixed;
  right: 0;
  top: 120px;
  z-index: 999;
  padding: 25px;
}

.resource-item {
  overflow: hidden;
  & > li {
    border: 1px solid #ebebeb;
    padding: 20px;
    max-width: 600px;
    margin-bottom: 20px;
  }
}
.control {
  margin-top: 40px;
}
</style>
